import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  messages: { text: string; type: string }[] = [];

  show(text: string, type: string = 'success') {
    this.messages.push({ text, type });
    setTimeout(() => this.messages.shift(), 3000);
  }
}
